export default [
    {
        path: '/notice',
        name: 'Notice',
        component: () => import('@/pages/notice/Notice.vue'),
        meta: {
            title: '系统通知',
            requireAuth: true
        },
        redirect: '/notice/productNews',
        children: [
            {
                path: 'productNews',
                name: 'ProductNews',
                component: () => import('@/pages/notice/product/ProductNews.vue'),
                meta: {
                    title: '产品动态',
                    requireAuth: true
                }
            },
            {
                path: 'shopNotice',
                name: 'ShopNotice',
                component: () => import('@/pages/notice/shop/ShopNotice.vue'),
                meta: {
                    title: '店铺通知',
                    requireAuth: true
                }
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/module/notice.js